<template>
  <div class="threads-box team-transferth-box" v-if="flag==index&&detailShow" id="threadsBox" >
    <!-- 显示该条任务下的source同步任务的详细信息 -->
    <div :class="[collapseIndex==index?'collapse-thread-box':'',]" class="thread-box" v-for="(itemSyncDetail, index) in syncItem.sources" :key="index" :style="{height:collapseIndex==index?getHeight(itemSyncDetail.syncDetail)+'px':''}">
      <div class="thread-all-backgroud">
        <div class="thread-all-back" v-show="itemSyncDetail.syncDetail.state2&&itemSyncDetail.syncDetail.state2.percent&&itemSyncDetail.syncDetail.state2.percent!=100"  :style="{width:itemSyncDetail.syncDetail.state2.percent+'%'}">
        </div>
      </div>
      <div class="thread-detail-bottom">
          <div class="business-thread-name">
          <div style="float:left">{{$t('language.common.from')}}: </div>
          <div class="thread-catelog"  @click.stop="toSourceCatalog(itemSyncDetail)" :title="itemSyncDetail.syncDetail.state2.sourceFilename">{{itemSyncDetail.syncDetail.state2.sourceFilename}}</div>
        </div>
        <div class="business-thread-name">
          <div style="float:left">{{$t('language.common.to')}}: </div>
          <div class="thread-catelog"  @click.stop="toAimCatalog(itemSyncDetail)" :title="itemSyncDetail.syncDetail.state2.desFilename">{{itemSyncDetail.syncDetail.state2.desFilename}}</div>
        </div>
        <div class="thread-status">
          <div class="thread-status-name" v-if="showStatus(itemSyncDetail)=='threadPercent'">
            <div>{{itemSyncDetail.syncDetail.state2.percent}}%</div>
          </div>
          <div class="thread-status-name" v-if="showStatus(itemSyncDetail)=='threadFailure'">{{$t('language.common.failure')}}</div>
          <div class="thread-status-name partical-color" v-if="showStatus(itemSyncDetail)=='particalStatus'">{{$t('language.common.partialSuccess')}}</div>
          <div class="thread-status-name color-green" v-if="showStatus(itemSyncDetail)=='threadSuccess'">
            {{$t('language.common.success')}}</div>
          <div class="thread-status-name" v-if="showStatus(itemSyncDetail)=='threadWaiting'">{{$t('language.common.waiting')}}...</div>
          <div class="thread-status-name" v-if="showStatus(itemSyncDetail)=='threadCancel'">{{$t('language.common.canceled')}}</div>
          <div class="thread-status-name" v-if="showStatus(itemSyncDetail)=='threadCount'">
            {{$t('language.common.countFiles')}}:({{itemSyncDetail.syncDetail.state2.readyFindFileCount}}{{$t('language.common.transferFiles')}},{{itemSyncDetail.syncDetail.state2.totalBytes|formatByte}})</div>
        </div>
        <div class="icon-util  white-up-position" :class="collapseIndex==index?'purple-down':'white-up'" @click="collapsePage(index,itemSyncDetail)"></div>
        <transition name="thread">
          <div  :class="isVip()?'sync-threads-vip':'sync-threads-detail'" v-if="collapseIndex==index" v-cloak>
            <div class="thread-detail">
              <syncThreadDetail ref="syncThreadDetail" :flag='collapseIndex' :index='index' :detailShow='itemDetailShow' :threadChange='threadChange' :itemSyncDetail='itemSyncDetail'></syncThreadDetail>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import taskListUtils from "@/js/workspace/task_list_util.js";
import syncThreadDetail from "@/components/common/tabs/tabs_task_list/tabs_businessThreads_detail";
import commonUtils from "@/js/workspace/common_util.js";
export default {
  props: ['syncItem', 'index', 'flag', 'detailShow', 'threadChange'],
  components: {
    syncThreadDetail
  },
  data: function () {
    return {
      collapseIndex: -1,
      clientHeight: 0,
      itemDetailShow: true,
      threadsDetail: this.detailShow,
      threadChangeSign:false,
      heightValue:0,//界面高度
    }
  },
  watch: {
    threadsDetail: (newValue, oldValue) => {
      if (!newValue) {
        this.$parent.$parent.$parent.$refs.threadParents[this.index].style.height = 95 + 'px ';
        let dom = this.$parent.$parent.$parent.$refs.threadParents[this.index].parentElement;
        dom.style.height = 95 + 'px ';
        this.collapseIndex = -1;
      }
    },
    //监听父组件，强制渲染数据和父组件一致
    '$store.state.threadChange': function (newValue, oldValue) {
      this.$forceUpdate();

    }
  },
  mounted () {
    //初始化应该打开同步任务的界面高度 
    this.initSyncItemPage();
  },
  methods: {
        isVip() {
            let flag = commonUtils.isVip();
            return flag;
        },
    toSourceCatalog(item){
     let name;
    if(item.fromItem){
     name=item.fromItem.name;
     }else{
     name=item.fromItem.nodes[0].fileName;
    }
   let fromItem = {
     driveId: item.fromItem.driveId,
     nodes: item.fromItem.nodes,
     driveType: item.fromItem.driveType,
     name: name,
     id: item.fromItem.id
    };
    //如果是多个的同步任务跳转到目标目录          
    this.$parent.$parent.toSourceCatalog(fromItem,'businessTransferAccount');                
    },    
    toAimCatalog(item){
     let name;
    if(item.toItem){
     name=item.toItem.name;
     }else{
     name=item.toItem.nodes[0].fileName;
    }
   let toItem = {
     driveId: item.toItem.driveId,
     nodes: item.toItem.nodes,
     driveType: item.toItem.driveType,
     name: name,
     id: item.toItem.id
    };
    //如果是多个的同步任务跳转到目标目录          
    this.$parent.$parent.toAimCatalog(toItem,'');                
    },
    //获取界面高度
    getHeight(value){
        var heightValue = 240;
        if(value &&value.entities && !value.entities.length){
            if(this.isVip()){
                heightValue=180;
            }
           return heightValue;
        }
        if(!this.isVip()){
            if(value.entities){
          heightValue = value.entities.length*25+20+240;
            }
        }else{
            if(value.entities){
          heightValue = value.entities.length*25+20+180;
            }
        }
        return heightValue;
    },
    initSyncItemPage(){
      this.$parent.$parent.$refs.threadParents.style.height = ((this.syncItem.sources.length) + 1) * 52 + 156 + 'px';
      let dom = this.$parent.$parent.$refs.threadParents.parentElement.parentElement;
      dom.style.height = ((this.syncItem.sources.length) + 1) * 52 +156 + 'px';
    },
    //打开或关闭界面
    collapsePage (index, itemSyncDetail) {
      let that = this;
     //console.log(itemSyncDetail);
      let dom = that.$parent.$parent.$refs.threadParents.parentElement.parentElement;
      let height = that.$parent.$parent.$refs.threadParents.clientHeight;
      if (this.collapseIndex != index) {//打开界面
        if (this.collapseIndex == -1) {//如果刚开始没有打开任何界面
          this.collapseIndex = index;
         if(itemSyncDetail.syncDetail&&itemSyncDetail.syncDetail.entities.length){//如果刚开始界面有线程运行
                var  heightValue = itemSyncDetail.syncDetail.entities.length*25 +20;
                var heightThreads = this.syncItem.sources.length*52;
                 if(!this.isVip()){
                dom.style.height = heightThreads+heightValue +260  + 150 + 'px ';
                that.$parent.$parent.$refs.threadParents.style.height = heightThreads+heightValue+260  + 150 + 'px ';
                 }else{
                dom.style.height = heightThreads+heightValue +200  + 150 + 'px ';
                that.$parent.$parent.$refs.threadParents.style.height = heightThreads+heightValue+200  + 150 + 'px ';        
                 }
               }else{
                 var heightThreads = this.syncItem.sources.length*52;
                 if(!this.isVip()){
                 dom.style.height = 260 +heightThreads + 150 + 'px ';
                 that.$parent.$parent.$refs.threadParents.style.height = 260 +heightThreads + 150 + 'px ';
                 }else{
                   dom.style.height = 200 +heightThreads + 150 + 'px ';
                 that.$parent.$parent.$refs.threadParents.style.height = 200 +heightThreads + 150 + 'px ';   
                 }
              }
          this.setSyncDetail(index,itemSyncDetail);
        } else {
          //打开界面另外一个企业云盘详情界面  
          this.collapseIndex = index;
         if(itemSyncDetail.syncDetail&&itemSyncDetail.syncDetail.entities.length){
                var  heightValue = itemSyncDetail.syncDetail.entities.length*25 +20;
                var heightThreads = this.syncItem.sources.length*52;
                 if(!this.isVip()){
                dom.style.height = heightThreads+heightValue +260  + 150 + 'px ';
                that.$parent.$parent.$refs.threadParents.style.height = heightThreads+heightValue+260  + 150 + 'px ';
                 }else{
                  dom.style.height = 200 +heightThreads+heightValue + 150 + 'px ';
                 that.$parent.$parent.$refs.threadParents.style.height = 200 +heightThreads+heightValue + 150 + 'px ';       
                 }
               }else{
                 var heightThreads = this.syncItem.sources.length*52;
                   if(!this.isVip()){
                dom.style.height = heightThreads +260  + 150 + 'px ';
                that.$parent.$parent.$refs.threadParents.style.height = heightThreads+260  + 150 + 'px ';
                 }else{
                  dom.style.height = 200 +heightThreads + 150 + 'px ';
                 that.$parent.$parent.$refs.threadParents.style.height = 200 +heightThreads + 150 + 'px ';       
                 }
              }
          this.setSyncDetail(index,itemSyncDetail);
        }
      } else {//关闭单个threads界面
        this.collapseIndex = -1;
        var heightThreads = this.syncItem.sources.length*52;
        dom.style.height = heightThreads + 210 + 'px ';
        that.$parent.$parent.$refs.threadParents.style.height = heightThreads + 210 + 'px ';
         
      }
    },
    setSyncDetail(index,itemSyncDetail){
     if(!itemSyncDetail.syncDetail&&localStorage.getItem('syncDetail'+itemSyncDetail.id)&&localStorage.getItem('syncDetail'+itemSyncDetail.id)!="null"&&JSON.parse(Base64.decode(localStorage.getItem('syncDetail'+itemSyncDetail.id)))){
          let Base64 = require('js-base64').Base64;
              if(index!=-2){
                   this.syncItem.sources[index].syncDetail=JSON.parse(Base64.decode(localStorage.getItem('syncDetail'+itemSyncDetail.id)));
              }else{
                   this.syncItem.syncDetail=JSON.parse(Base64.decode(localStorage.getItem('syncDetail'+itemSyncDetail.id)));
              }
          }
    },
    //关闭界面
    closePage () {
      this.$parent.$parent.$refs.threadParents.style.height = 95 + 'px ';
      let dom = this.$parent.$parent.$refs.threadParents.parentElement.parentElement;
      dom.style.height = 95 + 'px ';
      this.collapseIndex = -1;
    },
    showHaveDoneStatus(syncItem){
        let flag=true;
          if(syncItem.syncDetail.state2 && syncItem.syncDetail.state2.response ){
           if(!isNaN(syncItem.syncDetail.state2.response)){
               flag=false;
              return flag;
           }
        }
        return flag;
    },
    showStatus(syncItem){
     //0.显示counting状态 1.waiting状态 2.running状态  3.显示进度状态 4.取消状态 5.部分成功状态  6.失败状态 7.成功状态
     let flag;
     //0.count状态
     if(syncItem.syncDetail&&syncItem.syncDetail.state2.status==1){
       flag='threadCount';
       this.$parent.$parent.initTask();
       return flag;
     }
     //1.waiting状态
     if (((syncItem.syncDetail && syncItem.syncDetail.state2.status == 0 &&syncItem.status!='Done') || (!syncItem.syncDetail.state2&&syncItem.status!='Done') || (syncItem.status=='Waiting'&&!syncItem.syncDetail.state2.percent))) {
        flag = 'threadWaiting';
         return flag;
      }
      //3.显示进度状态
     if(syncItem.syncDetail.state2 && syncItem.syncDetail.state2.status >1 &&!isNaN(syncItem.syncDetail.state2.response) && syncItem.syncDetail.state2.percent!=100){
          flag = 'threadPercent';
           return flag;
     } 
     // 任务必须完成
     if(syncItem.syncDetail.state2.percent==100||this.showHaveDoneStatus(syncItem)||(syncItem.percent==100 && (syncItem.status=='Done'||syncItem.status=='Normal'))){
        //4.取消状态
         if ((syncItem.status == 'Done'||syncItem.status=='Normal')  && (syncItem.result == 'cancel'||(syncItem.syncDetail.state2&&syncItem.syncDetail.state2.response&&syncItem.syncDetail.state2.response=='cancel'))) {
            flag = 'threadCancel';
             return flag;
          }
        //详情存在情况下的5部分成功状态   //6失败状态
        if(syncItem.syncDetail.state2){
            if(syncItem.syncDetail.state2.errorList){
            if(syncItem.syncDetail.state2.errorList.length){
               if((syncItem.syncDetail.state2.errorList.length/syncItem.syncDetail.state2.totalFileCount)*100<20){
                 flag='particalStatus';
                 return flag;
               }else{
                  flag = 'threadFailure';
                  return flag;
               }
            }else{ //7. 成功状态
                if(syncItem.syncDetail.state2.percent==100){
                     flag='threadSuccess';
                     return flag;    
                }
            }
           }else{
                if(syncItem.syncDetail.state2.percent==100 ||syncItem.percent==100 ||(syncItem.status=='Normal'&&syncItem.result=='success')){
                     flag='threadSuccess';
                     return flag;    
                }
                 //部分成功状态
                 if(syncItem.result == 'error'){
                      if((syncItem.errorFileCount/syncItem.totalFileCount)*100<20){
                     flag='particalStatus';
                     return flag;
                   }else{
                    flag = 'threadFailure';
                     return flag;
                 }
                 }
           }
        }else{  //5部分成功状态   //6失败状态
        if(syncItem.status=='Done'){
            if(syncItem.syncDetail.state2.errorFileCount){
                if((syncItem.syncDetail.state2.errorFileCount/syncItem.syncDetail.state2.totalFileCount)*100<20){
                flag='particalStatus';
                return flag;
                }else{
                flag = 'threadFailure';
                return flag;
               }
            }else{ //7. 成功状态
                 if(syncItem.status!='Running'&&syncItem.status!='Waiting'&&syncItem.result!='error'){
                     flag='threadSuccess';
                     return flag;           
                 }
                 //部分成功状态
                 if(syncItem.result=='error'){
                      if((syncItem.errorFileCount/syncItem.totalFileCount)*100<20){
                     flag='particalStatus';
                     return flag;
                   }else{
                    flag = 'threadFailure';
                     return flag;
                 }
                 }
            }
           }
         }
     }else{//任务内存满了在运行过程中取消
        if(syncItem.syncDetail.state2&&syncItem.syncDetail.state2.runningStatus == -1){
             flag = 'threadCancel';
             return flag;
        }
         if(syncItem.syncDetail.state2){
            if(syncItem.syncDetail.state2.errorList){
            if(syncItem.syncDetail.state2.errorList.length){
               if((syncItem.syncDetail.state2.errorList.length/syncItem.syncDetail.state2.totalFileCount)*100<20){
                 flag='particalStatus';
                 return flag;
               }else{
                  flag = 'threadFailure';
                  return flag;
               }
            }
         }
         }


     }
     return flag;

    }

  },
}
</script>

<style scoped>
.partical-color{
    color: #4281ff;
}
.threads-box {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  /*no*/
  font-size: 12px;
  /*no*/
  color: #6f7886;
}

.collapse-threads-box {
  height: calc(100% + 300px);
}

.threads-title {
  color: black;
  font-weight: bold;
  margin-bottom: 20px;
  /*no*/
}

.thread-box {
  width: 100%;
  height: 40px;
  /*no*/
  border: 1px solid #eff5fd;
  /*no*/
  margin-bottom: 10px;
  /*no*/
  line-height: 40px;
  /*no*/
  position: relative;
}

.business-thread-name {
  margin-left: 1.5%;
  float: left;
  width: 29.1%;
  height: 40px;
  /*no*/
}

.thread-speed {
  float: left;
  width: 130px;
  /*no*/
  height: 40px;
  /*no*/
}

.thread-status {
  float: right;
  width: 30%;
  height: 40px;
  /*no*/
}
.team-transferth-box{
    padding: 0Px;
}
.thread-status-name {
  height: 100%;
  text-align: right;
  float: right;
  position: relative;
  left: -40px;  /*no*/
}

.color-green {
  color: #24d45a;
}

.color-blue {
  color: #4281ff;
}

.color-grey {
  color: #bfbfbf;
}

.color-red {
  color: red;
}

.white-up-position {
  position: absolute;
  top: 10px;
  /*no*/
  bottom: 0;
  right: 10px;
  /*no*/
  z-index: 800;
}

.collapse-thread-box {
  width: 100%;
  height: 340px;
  /*no*/
  border: 1px solid #cdddf5;
  /*no*/
}

.threads-detail {
  position: relative;
  top: 40px;
  /*no*/
  width: 100%;
  height: 300px;
  /*no*/
}

.sync-threads-detail {
  position: relative;
  top: 40px;
  /*no*/
  width: 100%;
  height: 200px;
  /*no*/
}

.sync-threads-vip {
  position: relative;
  top: 40px;
  /*no*/
  width: 100%;
  height: 180px;
  /*no*/
}

.thread-detail {
  position: absolute;
  width: 100%;
  height: 100%;
}

.thread-enter-active {
  transition: all 0.3s ease;
  height: 200px;
  /*no*/
  position: relative;
  top: 0px;
  /*no*/
  overflow: hidden;
}

.thread-leave-active {
  transition: all 0s ease;
  height: 0px;
  /*no*/
  overflow: hidden;
}

.thread-enter,
.thread-leave {
  height: 0;
  opacity: 0;
}

.thread-catelog {
  float: left;
  max-width: 400px;
  /*no*/
  height: 40px;
  /*no*/
  /*no*/
  color: #4280fe;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.thread-catelog:hover{
    text-decoration: underline;
}

.thread-all-back {
  background: #e5f0ff;
  height: 35px;
  /*no*/
  position: absolute;
  top: 2.25px;
  /*no*/
  bottom: 0;
}

.thread-all-backgroud {
  width: 100%;
  height: 40px;
  /*no*/
  position: absolute;
  float: left;
}

.thread-detail-bottom {
  width: 100%;
  height: 40px;
  /*no*/
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_task_list/tabs_businessTransfer_threads.vue